import { useMemo } from 'react'

import { ClaimStatusTypes } from '../models/ClaimStatus.model'
import { ClaimedPage } from '../services/ClaimPages/ClaimedPagesService'

export type PageViewerRole = 'owner' | 'pending_claimant' | 'pending_public' | 'verified_public' | 'claimable'

type UsePageViewerRoleParams = {
  pageId: number
  pageClaimStatus?: ClaimStatusTypes
  myPageEntry?: ClaimedPage | null
  isOrgAdmin?: boolean
  pageType: 'hospital' | 'agency'
}

const isApprovedClaim = (status?: string): boolean => {
  const lower = (status || '').toLowerCase()
  return lower === 'approved' || lower === 'claimed'
}

const isPendingClaim = (status?: string): boolean => {
  return (status || '').toLowerCase() === 'pending'
}

export const usePageViewerRole = ({
  pageId,
  pageClaimStatus,
  myPageEntry,
  isOrgAdmin,
  pageType,
}: UsePageViewerRoleParams): PageViewerRole => {
  return useMemo(() => {
    const pageStatus = pageClaimStatus || ClaimStatusTypes.UNCLAIMED
    const myStatus = myPageEntry?.claimStatus

    if (myPageEntry && String(myPageEntry.id) === String(pageId) && isApprovedClaim(myStatus)) {
      if (pageType === 'hospital' && isOrgAdmin) {
        return 'owner'
      }
      if (pageType === 'agency') {
        return 'owner'
      }
    }

    if (pageStatus === ClaimStatusTypes.PENDING) {
      if (myPageEntry && String(myPageEntry.id) === String(pageId) && isPendingClaim(myStatus)) {
        return 'pending_claimant'
      }
      return 'pending_public'
    }

    if (pageStatus === ClaimStatusTypes.ACCEPTED) {
      return 'verified_public'
    }

    return 'claimable'
  }, [pageId, pageClaimStatus, myPageEntry, isOrgAdmin, pageType])
}

export const getClaimEmail = (myPageEntry?: ClaimedPage | null, fallbackEmail?: string): string => {
  return myPageEntry?.requesterEmail || fallbackEmail || 'your email'
}

export const shouldShowVerifiedBadge = (role: PageViewerRole, pageType: 'hospital' | 'agency'): boolean => {
  if (role === 'verified_public') return true
  if (role === 'owner' && pageType === 'agency') return true
  return false
}
